import Grid from '@material-ui/core/Grid'
import React, { Component } from 'react'
import { getCardEnableData, getEMPI, getMyneedsEOS, getMyneedsEOSnew } from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import ChatIcon from '../../WebScreen/ChatBox/ChatIcon'
import MobCopyright from '../MobCopyright'
import { Button, Tab, Tabs } from '@material-ui/core'
import MyNeedsSimpleAccordion from '../MobileCommonComponents/myneedsAccordion'
import MobileHeader from '../MobileHeader'
import customStyle from '../../WebScreen/programInfo/CSS/stylesheet_UHS'
import { withStyles } from '@material-ui/styles'
import MobileFooter from './../MobileFooter'
import ContributionmyneedsAccordion from '../MobileCommonComponents/ContributionmyneedsAccordion'
import ContributionAccordian from '../MobileCommonComponents/ContributionAccordion'
import Reimbursements from '../../WebScreen/Reimbursement/Reimbursements'
import axios from 'axios'
import jsPDF from 'jspdf'
import ReimbursementUpload from '../../WebScreen/Reimbursement/ReimbursementUpload'

import Modal1 from 'react-awesome-modal'

const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

export default class MyNeedsMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      sampleData: sampleData,
      response: [],
      formatedjsonData: null,
      page: 0,
      loader: true,
      loadMoreBtnshow: false,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '',
      tabEnable: localStorage.getItem("isAdmin") || localStorage.getItem("NETWORK_NAME") == "senior65" ? true: false,
      selectedTab:"MyShareRequests",
      isReimbursementFlow: false,
      files: [],
    }
  }

  componentDidMount() {
    this.getCardEnable()
    this.getEMPID()
    this.callapi()
  }

  getEMPID() {
    getEMPI().then(res => {
      console.log('=============getEMPI===========', res)
    })
  }

  callapi() {
    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============MY needs data mobile===========', res.data)
      if (res.data.length > 0) {
        this.setState({ response: res.data, loader: false })
      } else {
        this.setState({
          notfoundmsg1:
            'No needs have been entered into the system. Submitted needs may take 2-3 days to be displayed here. For any clarifications call Customer Service.',
          loader: false
        })
      }

      if (res.data.length > 10) {
        this.setState({ loadMoreBtnshow: true })
      }
      this.setState({ response: res.data, page: this.state.page + 1, loader: false })
      this.createjson()
    })
  }

  callapiLoadmore() {
    this.setState({ loader: true })

    getMyneedsEOS(this.state.page).then(res => {
      console.log('==============TRansaction data mobile===========', res.data)
      console.log('my loade more res===', res)
      var resnew = res.data
      var data = this.state.response
      var newdata = data.concat(resnew)

      console.log('new data loade more is==', newdata)

      if (res.data.totalrecords === newdata.length) {
        this.setState({ loadMoreBtnshow: false })
      }
      this.setState({ response: newdata, loader: false, page: this.state.page + 1 })
      this.createjson()
    })
  }

  getCardEnable = () => {
    let client_id = localStorage.getItem('CLIENT_ID')

    getCardEnableData(client_id, 'MyNeeds').then(res => {
      console.log('getCardEnableData=====', res.data.response.enable)

      if (res.data.response.enable == 'false' || res.data.response.enable == false) {
        window.location.href = '/'
      }
    })
  }
  combineDate = (x, y) => {
    if (x == y) {
      return x
    }

    const z = x + '-' + y
    return z
  }
  createjson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      newobject.ExpenseNumberLabel = 'Expense Number'
      newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.start_of_service_date, item.end_date_of_service),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Allowed Amount',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),
        
        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        // SharedByUHFLabel: 'Shared By UHF',
        // SharedByUHFVal: '$' + item.paid_amount
      }

      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat(newobject)
    })

    this.setState({ formatedjsonData: formatredjson })
  }
  Contributioncreatejson() {
    var formatredjson = []

    this.state.response.map((item, i) => {
      var newobject = {}
      // newobject.ExpenseNumberLabel = 'Reference #'
      // newobject.ExpenseNumberVal = item.bill_key

      newobject.DateOfServiceLabel = 'Date of Service'
      newobject.DateOfServiceVal = item.service_date

      newobject.statusClass = item.status
      newobject.status = item.status

      newobject.ProviderLabel = 'Provider'
      newobject.ProviderVal = item.paid_provider_name

      newobject.ChargedLabel = 'Charged Amount'
      newobject.ChargedVal = item.charged_amount

      newobject.PaidLabel = 'Paid Amount'
      newobject.PaidVal = item.paid_amount

      newobject.row7 = 'Member'
      newobject.rowval7 = item.first_name + ' ' + item.last_name

      newobject.row8 = 'Paid Date'
      newobject.rowval8 = item.date_received

      var innerobject = {
        DateofServiceLabel: 'Date(s) of Service',
        DateofServiceVal: this.combineDate(item.service_date),

        ProviderNameLabel: 'Provider',
        ProviderNameVal: item.paid_provider_name,

        BillChargeLabel: 'Amount Billed',
        BillChargeVal: '$' + item.charged_amount.toFixed(2),

        IneligibleforSharingLabel: 'Ineligible for Sharing',
        IneligibleforSharingVal: '$' + item.ineligible_amount.toFixed(2),

        DiscountToBilledChargesLabel: 'Adjustment',
        DiscountToBilledChargesVal: '$' + item.repricing_amount.toFixed(2),

        EligibleforSharingLabel: 'Eligible for Sharing',
        EligibleforSharingVal: '$' + item.eligible_for_sharing.toFixed(2),

        NonShareableAmountLabel: 'Non-Shareable Amount',
        NonShareableAmountVal: '$' + item.non_sharable_amount.toFixed(2),

        ConsultationFeeLabel: 'Consultation Fee',
        ConsultationFeeVal: '$' + item.consultation_fee.toFixed(2),

        ShareableAmountLabel: 'Shared Amount',
        ShareableAmountVal: '$' + item.shared_amount.toFixed(2),

        MemberResponsibilityLabel: 'Member Responsibility',
        MemberResponsibilityVal: '$' + item.member_responsibility.toFixed(2),

        paidDateLabel: '	Paid Date',
        paidDateVal: item.date_paid,
        RepricedAmountLabel:"Repriced Amount",
        RepricedAmountVal: "$"+item.repricing_amount,
        MCPVLabel:`Visit Fees\n (MCP)`,
        MCVPValue: "$0.00",
        MCPLabel:"Member Commitment Portion (MCP)",
        MCPvalue:"$"+item.mcp,
        ShareableAmountLabel:"Shareable Amount",
        ShareableAmountValue:"$0.00",

        // SharedByUHFLabel: 'Paid Amount',
        // SharedByUHFVal: '$' + item.paid_amount
      }

      newobject.MoreDetail = innerobject

      formatredjson = formatredjson.concat(newobject)
    })

    this.setState({ formatedjsonData: formatredjson })
  }

  submitReimbursement = async () => {
    this.setState({ loader: true });
    const formatTimestamp = () => {
      const now = new Date();
      return now.toISOString().slice(0, 19).replace("T", " ");
    };
  
    const { files } = this.state;
    const memberId = localStorage.getItem('Member_EMPID').replace(/\D/g, "");
    const formattedTimestamp = formatTimestamp();
  
    const pdfFiles = files.filter(file => file.type === "application/pdf");
    const imageFiles = files.filter(file => file.type.startsWith("image/"));

    const renameFile = (file, newName) => {
      return new File([file], newName, { type: file.type });
    };

    const uploadFile = async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append(
        "requestData",
        JSON.stringify({
          memberId,
          claimId: null,
          status: "Being Processed",
          uploadedDate: formattedTimestamp,
        })
      );
  
      try {
        await axios.post(`${process.env.REACT_APP_NEW_BASE_URL}/memberportal/claims`, formData);
      } catch (error) {
        console.error("Upload failed:", error);
      }
    };

    for (let pdf of pdfFiles) {
      const newFileName = `${pdf.name.split(".")[0]}_${memberId}_${formattedTimestamp}.pdf`;
      const renamedPdf = renameFile(pdf, newFileName);
      await uploadFile(renamedPdf);
    }

    if (imageFiles.length > 0) {
      const pdf = new jsPDF();
      
      for (let i = 0; i < imageFiles.length; i++) {
        const imgData = await this.readFileAsDataURL(imageFiles[i]);
        const img = new Image();
        img.src = imgData;
  
        await new Promise(resolve => {
          img.onload = () => {
            const width = pdf.internal.pageSize.getWidth();
            const height = (img.height / img.width) * width;
            if (i > 0) pdf.addPage();
            pdf.addImage(img, "JPEG", 0, 0, width, height);
            resolve();
          };
        });
      }

      const pdfBlob = pdf.output("blob");
      const mergedPdfFile = new File([pdfBlob], `claimsPDF_${memberId}_${formattedTimestamp}.pdf`, { type: "application/pdf" });

      await uploadFile(mergedPdfFile);
    }

    this.setState({ loader: false });
    this.reimbursementFlowChange();
  };

  readFileAsDataURL = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  };

  readFileAsDataURL = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  };

  reimbursementFlowChange = () => {
    this.setState({ isReimbursementFlow: !this.state.isReimbursementFlow })
  }

  render() {
    const { formatedjsonData } = this.state

    return (
      <div className="">
        {this.state.loader ? <CommonLoader /> : null}
        <MobileHeader name="My Needs" />
        {
          this.state.isReimbursementFlow ?
          <ReimbursementUpload backClick={()=>this.setState({isReimbursementFlow:false, memberid:null, referenceId:null, selectedTab:"reimbursements"})}/>
          :
          <>
        {this.state.tabEnable && <AntTabs
                  value={this.state.selectedTab}
                  onChange={(e, newValue) => this.setState({selectedTab: newValue})}
                  textColor="#33333"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                  id="tabs"
                  style={{ width: '100%',height:'auto',marginTop: 25, justifyContent: "center"}}
                >
                  <Tab label="MY NEEDS" value="MyShareRequests" style={{ textTransform: 'capitalize',width:'33%',marginTop:window.mobileAndTabletCheck()? "28px":"10px",fontSize:"4vw",color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e' }} />
                  {
                    localStorage.getItem("isAdmin") &&
                    <Tab label="MY CONTRIBUTIONS" value="MyCONTRIBUTIONS" style={{ textTransform: 'capitalize',width:'33%',margin:window.mobileAndTabletCheck()? "40px 0px 4px 0px":"10px 0px 0px 0px",fontSize:"4vw",color: this.state.selectedTab == 'MyCONTRIBUTIONS' ? '#000' : '#7e7e7e'  }} />
                  }
                  {
                    localStorage.getItem("NETWORK_NAME") == "senior65" &&
                    <Tab label="MY REIMBURSEMENTS" value="reimbursements" style={{ textTransform: 'capitalize',width:'37%',margin:window.mobileAndTabletCheck()? "40px 0px 4px 0px":"10px 0px 0px 0px",fontSize:"4vw",color: this.state.selectedTab == 'reimbursements' ? '#000' : '#7e7e7e'  }} />
                  }
          </AntTabs>}

        {this.state.formatedjsonData ? (
          <div className={this.state.tabEnable ?"mobileCommonBodyContribution":"mobileCommonBody"}>
            <div>
            {this.state.tabEnable && this.state.selectedTab === "MyShareRequests" ?
                  <ContributionmyneedsAccordion data={formatedjsonData}/>
                  : !this.state.tabEnable && <MyNeedsSimpleAccordion data={formatedjsonData} />}
                  {this.state.tabEnable && this.state.selectedTab === "MyCONTRIBUTIONS" &&
                  <ContributionAccordian/>}

              {this.state.tabEnable && this.state.selectedTab === "reimbursements" &&
                <div key={this.state.isReimbursementFlow}>
                  <Reimbursements isReimbursementFlow={this.state.isReimbursementFlow} files={this.state.files} setFiles={(v) => this.setState({ files: v })} />
                </div>}

              {this.state.loadMoreBtnshow ? (
                <div className="loadMoreWrapper">
                {!this.state.tabEnable &&  <button className="loadMoreBtn" onClick={() => this.callapiLoadmore()}>
                    Load More
                  </button>}
                </div>
              ) : null}

              {this.state.selectedTab == "MyShareRequests" && this.state.notfoundmsg1 == '' ? (
                <Grid container style={{ padding: '10px', backgroundColor: 'white' }}>
                  <span style={{ fontStyle: 'Roboto', fontWeight: '500' }}>
                    **For complete status, please refer to the Explanation of Sharing (EOS) mailed to your address on file
                  </span>
                </Grid>
              ) : null}
            </div>

            {this.state.notfoundmsg1 == '' ? null : (
              this.state.selectedTab == "MyShareRequests" &&
              <div style={{ padding: '180px 0px', textAlign: 'center' }} className="mobile_data_not_found">
                {this.state.notfoundmsg1}
              </div>
            )}
          </div>
        ) : null}

        {/* {this.state.loader ? null : (
          <div style={{ bottom: '9vh', position: 'fixed', display: 'flex', flexDirection: 'column' }}>
            <ChatIcon showAIChatIcon={true} />
            <div >
              <ChatIcon />
            </div>
            <div style={{ bottom: '9vh', position: 'fixed' }}>
              <MobCopyright />
            </div>
          </div>
        )} */}
        {/* <MobileFooter /> */}
        {/* <div class="fixed-bottom">
          <MobileFooter name="My Needs" />
        </div> */}
        {this.state.loader ? null : (
          <div>
            <div>
            <div style={{ bottom: '6vh', position: 'relative' }}>
            <ChatIcon showAIChatIcon={true} />
            <ChatIcon setAI={() => this.setState({ isAI: true })} />
            <MobCopyright />
          </div>
          </div>
        
          <div class="fixed-bottom">
            <MobileFooter name="My Needs"/>
          </div>
          </div>
      )}
      </>}

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">
              This service is currently offline. Please try again later.
            </div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
}

const sampleData2 = [
  { id: 733, planId: '7006', idcardField: 'Telemedicine', fieldValue: '$0' },
  { id: 735, planId: '7006', idcardField: 'PCP Office Visit', fieldValue: '$35' },
  { id: 736, planId: '7006', idcardField: 'Urgent Care', fieldValue: '$100' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' }
]
const sampleData = [
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1248',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 22, 2020',
    statusClass: 'InReview',
    status: 'In Review',
    ProviderLabel: 'Provider',
    ProviderVal: 'Healthway Clinic',
    ChargedLabel: 'Charged',
    ChargedVal: '$505.00',
    PaidLabel: 'Paid',
    PaidVal: 'NA',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Jane Doe',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'May 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$4800.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$0.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1000.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$300.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$320.00'
    }
  },
  {
    ExpenseNumberLabel: 'Expense Number',
    ExpenseNumberVal: '1259',
    DateOfServiceLabel: 'Date of Service',
    DateOfServiceVal: 'July 20, 2020',
    statusClass: 'Final',
    status: 'Final',
    ProviderLabel: 'Provider',
    ProviderVal: 'Apollo Hospital',
    ChargedLabel: 'Charged',
    ChargedVal: '$350.00',
    PaidLabel: 'Paid',
    PaidVal: '$1800.00',
    MoreDetail: {
      MemberLabel: 'Member',
      MemberVal: 'Marry Jim',
      PaidDateLabel: 'Paid Date',
      PaidDateVal: 'Feb 27, 2020',
      EOSLabel: 'EOS',
      RepricingDiscountLabel: 'Repricing Discount',
      RepricingDiscountVal: '$2500.00',
      IneligibleAmountLabel: 'Ineligible Amount',
      IneligibleAmountVal: '$20.00',
      NonSharableAmountLabel: 'Non-Sharable Amount',
      NonSharableAmountVal: '$1500.00',
      ConsultationFeeLabel: 'Consultation Fee',
      ConsultationFeeVal: '$350.00',
      SharingPercentageLabel: 'Sharing Percentage',
      SharingPercentageVal: '$420.00'
    }
  }
]
